var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupe76099(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 49.263,
    viewBox: "0 0 65 49.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_76099",
    "data-name": "Groupe 76099",
    transform: "translate(-943 -556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop_device",
    "data-name": "laptop device",
    transform: "translate(943 556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26941",
    "data-name": "Trac\\xE9 26941",
    d: "M8,13.478A3.477,3.477,0,0,1,11.478,10H32.346a3.477,3.477,0,0,1,3.478,3.478V29.129H8Z",
    transform: "translate(-1.044 -1.305)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26942",
    "data-name": "Trac\\xE9 26942",
    d: "M4,38H33.077",
    transform: "translate(-0.522 -4.958)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26943",
    "data-name": "Trac\\xE9 26943",
    d: "M0,0H41.737V41.737H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "people_multiple",
    "data-name": "people multiple",
    transform: "translate(975.158 572.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26944",
    "data-name": "Trac\\xE9 26944",
    d: "M8,8.105A4.105,4.105,0,1,0,12.105,4,4.109,4.109,0,0,0,8,8.105Z",
    transform: "translate(11.158 -1.263)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26945",
    "data-name": "Trac\\xE9 26945",
    d: "M4.528,24h5.611a4.108,4.108,0,0,1,4.078,3.6l.876,7.006a2.74,2.74,0,0,1-2.716,3.079H5.9",
    transform: "translate(14.63 -7.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26946",
    "data-name": "Trac\\xE9 26946",
    d: "M24.55,34.605l.876-7.006A4.108,4.108,0,0,1,29.5,24h3.011a4.108,4.108,0,0,1,4.078,3.6l.876,7.006a2.74,2.74,0,0,1-2.716,3.079H27.266A2.74,2.74,0,0,1,24.55,34.605Z",
    transform: "translate(-21.43 -7.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26947",
    "data-name": "Trac\\xE9 26947",
    d: "M28,7.373A3.373,3.373,0,1,0,31.373,4,3.376,3.376,0,0,0,28,7.373Z",
    transform: "translate(-21.794 0.202)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26948",
    "data-name": "Trac\\xE9 26948",
    d: "M32.842,0H0V32.842H32.842Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe76099);
export default __webpack_public_path__ + "static/media/Groupe 76099.eac35d64b2a6cf73e9aa2a7aea0624e5.svg";
export { ForwardRef as ReactComponent };